import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IAnalysisSidebarTabs from './interfaces/IAnalysisSidebarTabs';

import styles from './scss/AnalysisSidebarTabs.module.scss';

function AnalysisSidebarTabs({
  activeTab,
  onTabChange,
}: IAnalysisSidebarTabs): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.tabs}>
      <Button
        variant={BUTTON_VARIANT.ghost}
        className={clsx(styles.tab, { [styles.tabActive]: activeTab === 'setup' })}
        onClick={() => onTabChange('setup')}
        title={t('valueChainMap.analysisSetup')}
      />
      <Button
        variant={BUTTON_VARIANT.ghost}
        className={clsx(styles.tab, { [styles.tabActive]: activeTab === 'results' })}
        onClick={() => onTabChange('results')}
        title={t('valueChainMap.analysisResults')}
      />
    </div>
  );
}

export default AnalysisSidebarTabs;
